import { View, Text, StyleSheet, TouchableOpacity } from 'react-native'
import { Ionicons } from '@expo/vector-icons'

// components
import ModalPopup from '../shared/modal/ModalPopup'
import { colorPalette, globalStyles } from '../../static/styles/global'

// types
import { WorkingHours } from '../../types/scheduleTypes'

interface dailyScheduleProps {
  day: string
  fromTo: string
}

const DailySchedule = ({ day, fromTo }: dailyScheduleProps): JSX.Element => {
  return (
    <View style={[globalStyles.hDirection]}>
      <View style={[]}>
        <Text style={[styles.dayCol, globalStyles.text, globalStyles.fs14]}>
          {day}:
        </Text>
      </View>
      <View style={[globalStyles.flexOne]}>
        <Text
          style={[
            globalStyles.text,
            globalStyles.fwSemiBold,
            globalStyles.fs14
          ]}
        >
          {fromTo}
        </Text>
      </View>
    </View>
  )
}

interface ToolTipProps {
  title?: string
  visible: boolean
  setVisible: any
  workingHours?: WorkingHours
}

const Tooltip = ({
  title,
  visible,
  setVisible,
  workingHours
}: ToolTipProps): JSX.Element => {
  return (
    <ModalPopup visible={visible}>
      <View style={styles.modalHeader}>
        <Text
          style={[
            globalStyles.text,
            globalStyles.fs18,
            globalStyles.fwBold,
            globalStyles.blackTextColor
          ]}
        >
          {title}
        </Text>
        <TouchableOpacity onPress={() => setVisible(!visible)}>
          <Ionicons name="close-sharp" size={24} color={colorPalette.black} />
        </TouchableOpacity>
      </View>
      <View style={[styles.modalBody]}>
        <View style={[styles.modalBodyInner]}>
          {/* <View
            style={[
              globalStyles.mb3,
              globalStyles.pb3,
              { borderBottomWidth: 1, borderBottomColor: colorPalette.light }
            ]}
          >
            <Text
              style={[
                globalStyles.text,
                globalStyles.fs14,
                globalStyles.fwSemiBold
              ]}
            >
              Working Hours: Giant - Store Brand
            </Text>
            <Text style={[globalStyles.text, globalStyles.fs14]}>
              12345 Southern Main St.
            </Text>
            <Text style={[globalStyles.text, globalStyles.fs14]}>
              Fredericksburg, VA 12345
            </Text>
          </View> */}
          <View style={[globalStyles.mb1]}>
            <DailySchedule day="Monday" fromTo={workingHours.mondayHours} />
            <DailySchedule day="Tuesday" fromTo={workingHours.tuesdayHours} />
            <DailySchedule
              day="Wednesday"
              fromTo={workingHours.wednesdayHours}
            />
            <DailySchedule day="Thursday" fromTo={workingHours.thursdayHours} />
            <DailySchedule day="Friday" fromTo={workingHours.fridayHours} />
            <DailySchedule day="Saturday" fromTo={workingHours.saturdayHours} />
            <DailySchedule day="Sunday" fromTo={workingHours.sundayHours} />
          </View>
        </View>
      </View>
    </ModalPopup>
  )
}

const styles = StyleSheet.create({
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingHorizontal: 16,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderColor: colorPalette.darkLight
  },
  modalBody: {
    paddingVertical: 0,
    paddingHorizontal: 0
  },
  modalBodyInner: {
    padding: 16
  },
  dayCol: {
    minWidth: 90
  }
})

export default Tooltip
